module.exports = __webpack_public_path__ + "media/components/img/logo-purple-54x60@2x-1a333b31d0585c7c744e5fd69020481d.png";